<template>
  <ModalDialog
    v-model="visible"
    :title="$localize('CctvExportFolderUploadModalTitle')"
    @open="resetState"
  >
    <template #default>
      <div>
        {{ $localize(folders?.length ? 'UploadCctvFolderPrompt' : 'UploadCctvZipPrompt') }}
      </div>
      <br>

      <div class="form-check">
        <input
          id="cctv-upload-acknowledge"
          v-model="state.cctvConfirmed"
          class="form-check-input"
          type="checkbox"
          required
          aria-describedby="cctvUploadConfirmationValidationMessage"
        >
        <label
          for="cctv-upload-acknowledge"
          class="form-check-label"
        >
          {{ $localize('CctvExportFolderUploadModalConfirmation') }}
        </label>
      </div>
    </template>
    <template #footer>
      <VueButton
        :type="VueButtonTypes.default"
        @click="visible = false"
      >
        {{ $localize('Cancel') }}
      </VueButton>
      <VueButton
        :type="VueButtonTypes.primary"
        :disabled="!state.cctvConfirmed"
        @click="onConfirm"
      >
        {{ $localize('Continue') }}
      </VueButton>
    </template>
  </ModalDialog>
</template>

<script setup lang="ts">
  import ModalDialog from '@/VueComponents/Modals/ModalDialog.vue';
  import UploadSelectorFileUploadModel from '@/VueComponents/FileUploadSelector/models/uploadSelectorFileUploadModel';
  import UploadSelectorFolderUploadModel from '@/VueComponents/FileUploadSelector/models/uploadSelectorFolderUploadModel';
  import { VueButtonTypes } from '@/VueComponents/SharedComponents/Buttons/Enums/vueButtonTypes';
  import VueButton from '@/VueComponents/SharedComponents/Buttons/VueButton.vue';
  import useResetableState from '@/VueCore/utils/useResetableState';

  const props = defineProps<{
    files?: UploadSelectorFileUploadModel[],
    folders?: UploadSelectorFolderUploadModel[]
  }>();

  const visible = defineModel<boolean>({ default: false });
  const { state, resetState } = useResetableState({
    cctvConfirmed: false
  });

  const emit = defineEmits<{
    'confirm': [UploadSelectorFileUploadModel[], UploadSelectorFolderUploadModel[]]
  }>();

  function onConfirm() {
    emit('confirm', props.files, props.folders);
  }
</script>
